import React from "react";
import { Outlet } from "react-router-dom";
import TopHeader from "./TopHeader";
import BottomNav from "./BottomNav";

export default function MobileShell() {
  return (
    <div className="min-h-screen bg-[#eef4ee] flex justify-center">
      <div className="relative w-full max-w-md bg-[#f8fcf8] min-h-screen shadow-2xl shadow-[#02371b]/10 sm:my-6 sm:rounded-[36px] sm:overflow-hidden sm:border-8 sm:border-[#02371b]/8 flex flex-col">
        <TopHeader />
        <main className="flex-1 pb-28 overflow-x-hidden">
          <Outlet />
        </main>
        <BottomNav />
      </div>
    </div>
  );
}
